const routes = [
  // 商品介绍页
  {
    path: '/enterprise/prodDetail',
    name: 'ProdDetail',
    meta: {
      hideHomeBtn: true, // 是否隐藏左上角返回按钮
      title: '定制ETC',
      region: 'ETC新办页',
      obj_name: '新办页曝光',
    },
    component: () => import('@/views/enterprise/prodDetail.vue')
  },
  // 聚合页
  {
    path: '/enterprise/center',
    name: 'Center',
    meta: {
      title: '我的ETC',
      requiresAuth: true,
      region: 'ETC服务页',
      obj_name: '服务页曝光',
    },
    component: () => import('@/views/enterprise/center.vue')
  },
  // 绑卡页
  {
    path: '/enterprise/bindCard',
    name: 'BindCard',
    meta: {
      title: 'ETC绑定',
      requiresAuth: true,
    },
    component: () => import('@/views/enterprise/bindCard.vue')
  },
  // 激活引导页
  {
    path: '/enterprise/activeGuide',
    name: 'BindActiveGuideCard',
    meta: {
      title: '激活绑定ETC',
    },
    component: () => import('@/views/enterprise/actGuide.vue')
  },
  // 售後引导页
  {
    path: '/enterprise/afterSaleGuide',
    name: 'AfterSaleGuide',
    meta: {
      title: 'ETC售后指引',
    },
    component: () => import('@/views/enterprise/afterSaleGuide.vue')
  },
  
  // 办理资格查询页
  {
    path: '/enterprise/checkPlate',
    name: 'CheckPlate',
    meta: {
      title: '办理资格查询',
      requiresAuth: true,
    },
    component: () => import('@/views/enterprise/checkPlate.vue')
  },
  // 办理资格查询页
  {
    path: '/enterprise/checkPlateResult',
    name: 'CheckPlateResult',
    meta: {
      title: '查询结果',
      requiresAuth: true,
    },
    component: () => import('@/views/enterprise/checkPlateResult.vue')
  },
  // 通行记录
  {
    path: '/enterprise/tollRec',
    name: 'TollRec',
    meta: {
      title: '通行记录',
      requiresAuth: true,
    },
    component: () => import('@/views/enterprise/tollRec.vue')
  },
  // 变更联系人
  {
    path: '/enterprise/changePhone',
    name: 'ChangePhone',
    meta: {
      title: '变更联系人',
      requiresAuth: true,
    },
    component: () => import('@/views/enterprise/changePhone.vue')
  },
  // 我的卡券
  {
    path: '/enterprise/myCoupon',
    name: 'MyCoupon', 
    meta: {
      title: '我的卡券',
      requiresAuth: true,
    },
    component: () => import('@/views/enterprise/myCoupon.vue')
  },
  // 订单确认
  {
    path: '/enterprise/orderConfirm',
    name: 'OrderConfirm',
    meta: {
      title: '订单确认',
    },
    component: () => import('@/views/enterprise/orderConfirm.vue')
  },
  // 扫码绑定（广汽车机）
  {
    path: '/enterprise/qrCodeBind',
    name: 'QrCodeBind',
    meta: {
      title: '扫码绑定',
      requiresAuth: true,
    },
    component: () => import('@/views/enterprise/qrCodeBind.vue')
  }
]

export default routes